import React from "react";
import "../Layout/Layout.css";
import Card from "../Card/Card";
import { Helmet } from "react-helmet";
import Plan from "../Plan/Plan";
const Layout = () => {
  return (
    <>
      <Helmet>
        {/* ----------------------------------------------------
      BASIC SEO TAGS
  ---------------------------------------------------- */}
        <title>
          ACE Hanei Layout Plans | 3.5, 4.5 & 4.5-XL BHK Floor Plans & Flat
          Sizes
        </title>
        <meta
          name="description"
          content="Explore ACE Hanei Sector 12 layout plans - Detailed floor plans for 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft) and 4.5-XL BHK (4190 sq.ft) luxury apartments in Noida Extension."
        />
        <meta
          name="keywords"
          content="ACE Hanei layout, ACE Hanei floor plans, ACE Hanei flat sizes, 3.5 BHK layout Noida Extension, 4.5 BHK floor plan, 4.5-XL BHK apartment layout, ACE Hanei apartment plans, flat designs Noida Extension, luxury apartment layouts, ACE Hanei sector 12 layouts, ACE Hanei blueprint, flat size details"
        />
        <link rel="canonical" href="https://acegroupsales.com/layout" />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#ffffff" />

        {/* ----------------------------------------------------
      OPEN GRAPH TAGS
  ---------------------------------------------------- */}
        <meta
          property="og:title"
          content="ACE Hanei Layout Plans - 3.5, 4.5 & 4.5-XL BHK Floor Plans"
        />
        <meta
          property="og:description"
          content="View detailed layout plans for ACE Hanei Sector 12 luxury apartments: 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft), 4.5-XL BHK (4190 sq.ft) floor plans and specifications."
        />
        <meta
          property="og:image"
          content="https://acegroupsales.com/poster.webp"
        />
        <meta property="og:url" content="https://acegroupsales.com/layout" />
        <meta property="og:type" content="website" />

        {/* ----------------------------------------------------
      TWITTER META TAGS
  ---------------------------------------------------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="ACE Hanei Layout & Floor Plans - Noida Extension"
        />
        <meta
          name="twitter:description"
          content="Detailed layout plans for ACE Hanei luxury apartments in Sector 12 Noida Extension. View 3.5, 4.5 & 4.5-XL BHK floor plans."
        />
        <meta
          name="twitter:image"
          content="https://acegroupsales.com/poster.webp"
        />

        {/* ----------------------------------------------------
      JSON-LD SCHEMA
  ---------------------------------------------------- */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "ACE Hanei Layout Plans - Floor Plans & Flat Sizes",
              url: "https://acegroupsales.com/layout",
              description:
                "Detailed layout plans and floor designs for ACE Hanei Sector 12 luxury apartments in Noida Extension. View 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft), and 4.5-XL BHK (4190 sq.ft) apartment layouts.",
              primaryImageOfPage: {
                "@type": "ImageObject",
                url: "https://acegroupsales.com/poster.webp",
              },
              breadcrumb: {
                "@type": "BreadcrumbList",
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: "Home",
                    item: "https://acegroupsales.com/",
                  },
                  {
                    "@type": "ListItem",
                    position: 2,
                    name: "Layouts",
                    item: "https://acegroupsales.com/layout",
                  },
                ],
              },
              mainEntity: {
                "@type": "ItemList",
                name: "ACE Hanei Flat Layout Plans",
                description:
                  "Collection of all apartment layout plans available at ACE Hanei Sector 12 Noida Extension",
                numberOfItems: 3,
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: "4.5-XL BHK Luxury Apartment Layout",
                    description:
                      "Ultra spacious 4.5-XL BHK apartment layout with 4190 sq.ft area",
                    image: "https://acegroupsales.com/a1.webp",
                    additionalProperty: [
                      {
                        "@type": "PropertyValue",
                        name: "Type",
                        value: "4.5-XL BHK",
                      },
                      {
                        "@type": "PropertyValue",
                        name: "Area",
                        value: "4190 SQ.FT.",
                      },
                      {
                        "@type": "PropertyValue",
                        name: "Layout Features",
                        value: "Extra Large Luxury Apartment",
                      },
                    ],
                  },
                  {
                    "@type": "ListItem",
                    position: 2,
                    name: "4.5 BHK Luxury Apartment Layout",
                    description:
                      "Luxury 4.5 BHK apartment layout with 3200 sq.ft area",
                    image: "https://acegroupsales.com/a3.webp",
                    additionalProperty: [
                      {
                        "@type": "PropertyValue",
                        name: "Type",
                        value: "4.5 BHK",
                      },
                      {
                        "@type": "PropertyValue",
                        name: "Area",
                        value: "3200 SQ.FT.",
                      },
                      {
                        "@type": "PropertyValue",
                        name: "Layout Features",
                        value: "Premium Luxury Apartment",
                      },
                    ],
                  },
                  {
                    "@type": "ListItem",
                    position: 3,
                    name: "3.5 BHK Luxury Apartment Layout",
                    description:
                      "Spacious 3.5 BHK apartment layout with 2290 sq.ft area",
                    image: "https://acegroupsales.com/poster.webp",
                    additionalProperty: [
                      {
                        "@type": "PropertyValue",
                        name: "Type",
                        value: "3.5 BHK",
                      },
                      {
                        "@type": "PropertyValue",
                        name: "Area",
                        value: "2290 SQ.FT.",
                      },
                      {
                        "@type": "PropertyValue",
                        name: "Layout Features",
                        value: "Spacious Family Apartment",
                      },
                    ],
                  },
                ],
              },
              about: [
                {
                  "@type": "Apartment",
                  name: "ACE Hanei 4.5-XL BHK Layout",
                  description:
                    "4.5-XL BHK luxury apartment layout with 4190 sq.ft area at ACE Hanei Sector 12",
                  numberOfRooms: "4.5-XL",
                  floorSize: {
                    "@type": "QuantitativeValue",
                    value: "4190",
                    unitCode: "FTK",
                    name: "Carpet Area",
                  },
                  image: "https://acegroupsales.com/a1.webp",
                },
                {
                  "@type": "Apartment",
                  name: "ACE Hanei 4.5 BHK Layout",
                  description:
                    "4.5 BHK luxury apartment layout with 3200 sq.ft area at ACE Hanei Sector 12",
                  numberOfRooms: "4.5",
                  floorSize: {
                    "@type": "QuantitativeValue",
                    value: "3200",
                    unitCode: "FTK",
                    name: "Carpet Area",
                  },
                  image: "https://acegroupsales.com/a3.webp",
                },
                {
                  "@type": "Apartment",
                  name: "ACE Hanei 3.5 BHK Layout",
                  description:
                    "3.5 BHK luxury apartment layout with 2290 sq.ft area at ACE Hanei Sector 12",
                  numberOfRooms: "3.5",
                  floorSize: {
                    "@type": "QuantitativeValue",
                    value: "2290",
                    unitCode: "FTK",
                    name: "Carpet Area",
                  },
                  image: "https://acegroupsales.com/poster.webp",
                },
              ],
              publisher: {
                "@type": "Organization",
                name: "ACE Group",
                url: "https://acegroupsales.com/",
                logo: "https://acegroupsales.com/1.webp",
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "+917303734500",
                  contactType: "Layout Information",
                  areaServed: "IN",
                  availableLanguage: ["English", "Hindi"],
                },
              },
              provider: {
                "@type": "RealEstateAgent",
                name: "Authorized Channel Partner - Shishir",
                telephone: "+917303734500",
                identifier: "UP RERA Registration No. UPRERAAGT24002",
              },
              mainEntityOfPage: {
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "What flat sizes are available at ACE Hanei?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "ACE Hanei offers three flat sizes: 4.5-XL BHK (4190 SQ.FT.), 4.5 BHK (3200 SQ.FT.), and 3.5 BHK (2290 SQ.FT.) luxury apartments.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can I view detailed layout plans for ACE Hanei apartments?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, detailed layout plans for all apartment configurations (3.5 BHK, 4.5 BHK, and 4.5-XL BHK) are available on our layouts page and can be viewed during site visits.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are the layout plans customizable?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "The basic layout structure is fixed, but certain interior modifications may be possible. Please contact our sales team at +917303734500 for customization options.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What is included in the 4.5-XL BHK layout?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "The 4.5-XL BHK layout at 4190 sq.ft includes extra-large living spaces, additional rooms, and premium configuration suitable for luxurious family living.",
                    },
                  },
                ],
              },
            }),
          }}
        />
      </Helmet>
      <div className="gappp">
        <Card />
      </div>
    </>
  );
};

export default Layout;
